import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { URLGIFTING } from '../config/setup/setup';
import httpCommonHeaders from '../helpers/httpCommonHeaders';

export const getGift = async (giftData) => {
  const { data } = await axios({
    cache: false,
    data: { gift: giftData },
    headers: httpCommonHeaders(),
    method: 'POST',
    url: URLGIFTING,
    withCredentials: true,
  });

  return data;
};
